export { Watch as default } from './Watch';
